import styled from '@emotion/styled';

const SelectFieldPlaceholder = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export default SelectFieldPlaceholder;
